import { render, staticRenderFns } from "./DoctorsListSkeleton.vue?vue&type=template&id=742e8e22"
import script from "./DoctorsListSkeleton.vue?vue&type=script&lang=js"
export * from "./DoctorsListSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports